const makeExpressionTransformer = ({
  transformer: transformByExpressionType
}) => {
  const transformExpression = (expression, {
    formatExpression = expressionString => expressionString
  } = {}) => {
    if (expression && expression.type) {
      const transformFunction = transformByExpressionType[expression.type];
      if (transformFunction && typeof transformFunction === 'function') {
        return formatExpression(transformByExpressionType[expression.type]({
          expression,
          transformExpression
        }));
      }
    }
    return '';
  };
  return transformExpression;
};
export default makeExpressionTransformer;